import React, { createContext, useContext, useState, useCallback } from 'react';
import i18n from '../i18n';
import { detectInitialLang, DINER_LANG_KEY } from '../i18n/detect';
import { MASTER_CODES } from '../i18n/languages';

export { detectInitialLang, DINER_LANG_KEY };

const SUPPORTED = MASTER_CODES;

const LanguageContext = createContext({ lang: 'en', setLang: () => {} });
export const useLanguage = () => useContext(LanguageContext);

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState(detectInitialLang);
  const setLang = useCallback((next) => {
    if (!SUPPORTED.includes(next)) return;
    setLangState(next);
    try { localStorage.setItem(DINER_LANG_KEY, next); } catch (e) { /* ignore */ }
    i18n.changeLanguage(next);
  }, []);
  return (
    <LanguageContext.Provider value={{ lang, setLang }}>
      {children}
    </LanguageContext.Provider>
  );
}
